module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I learned this, at least, by my experiment:")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("that if one advances confidently in the direction of his dreams,")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("and endeavors to live the life which he has imagined,")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("he will meet with a success unexpected in common hours.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—Henry David Thoreau")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0